module.exports = __webpack_public_path__ + "img/red-package-open.be666e9f.png";